// extracted by mini-css-extract-plugin
export default {"titleForm":"default-email-header_titleForm__YfxA4","subtitleForm":"default-email-header_subtitleForm__Zdbrx"};